<template>
  <div class="mitad carousel_contenedor">
    <!-- slides -->
    <div class="carousel">
      <div class="carousel-track"
        :style="{ transform: 'translateX(-' + currentSlide * 100 + '%)' }"
      >
        <div class="slide" v-for="(slide,index) in configuracionSlide" :key="index">
          <!-- mostrar fondo relacionado con la imagen -->
          <div class="slide-bg" :style="{backgroundImage:'url(' + obtenerImagen(slide.imagen) + ')'}"></div>
            <img class="slide-img" :src="obtenerImagen(slide.imagen)" alt="slide">
        </div>
      </div>

      <!-- flechas -->
      <div class="flechas" v-if="configuracionSlide.length > 1">
        <button class="arrow left" @click="atrasSlide"><i class="fa-solid fa-angle-left icono"></i></button>
        <button class="arrow right" @click="siguienteSlide"><i class="fa-solid fa-angle-right icono"></i></button>
      </div>
      
      <!-- indicadores -->
      <div class="dots">
        <span v-for="(slide,index) in configuracionSlide" :key="index" class="dot" 
          :class="{active:index===currentSlide}"
          @click="goToSlide(index)">
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import servicioCliente from '@/services/servicioCliente';

export default {
  data(){
    return{
      currentSlide:0,
      interval:null,
      configuracionSlide:[],
      
      imagenes:[]
    }
  },
  mounted(){
      this.obtenerConfiguracionSlide();
      //this.cargarFoto()
  },
  beforeUnmount(){
    clearInterval(this.interval)
  },
  
  methods:{
    //Intervalo de movimiento
    startAuto(){
      this.interval = setInterval(()=>{
        this.siguienteSlide()
      },6000)
    },

    //Método para obtener lista de slide
    async obtenerConfiguracionSlide(){
      try{
        const result = await servicioCliente.obtenerConfiguracionSlide(3,{SlideID:0});
        this.configuracionSlide = result.data
              //console.log( this.configuracionSlide);
              
        // iniciar autoplay cuando ya hay datos
        if(this.configuracionSlide.length > 0){
          this.startAuto();
        }

        const slide = result.data[0]
        this.imagenes = slide.imagen

        //guardar slides validos
        this.configuracionSlide = result.data.filter(slide => this.slideValido(slide));

        this.$emit(
          'slide-activo',
          this.configuracionSlide.length > 0
        );
        //iniciar autoplay cuando ya hay datos
        // if(this.configuracionSlide.length > 0){
        //   this.startAuto();
        // }
      } catch(error){
        this.$msg.error("No es posible consultar la Información");
      }
    },

    //Siguiente slide
    siguienteSlide(){
      this.currentSlide++
      if(this.currentSlide >= this.configuracionSlide.length){
        this.currentSlide = 0
      }
    },

    //Slide anterior
    atrasSlide(){
      this.currentSlide--
      if(this.currentSlide < 0){
        this.currentSlide = this.configuracionSlide.length - 1
      }
    },
      
    goToSlide(index){
      this.currentSlide = index
    },

    //Método para mostrar slide con estatus true y correspondan a la vigencia
    slideValido(slide){
      //Slide activo
      if(!slide.estatus) 
        return false;

      //si no se solicitó vigencia se muestra
      if(!slide.solicitarVigencia) 
        return true;

      const hoy = new Date();
      const inicio = new Date(slide.fechaInicioVigencia);
      const fin = new Date(slide.fechaFinalVigencia);
      
      return hoy >= inicio && hoy <= fin;
    },

    obtenerImagen(bytes){

      if(!bytes || bytes.length === 0){
          return ''
      }
      const binary = bytes.reduce(
          (acc, byte) => acc + String.fromCharCode(byte),
          ''
      )
      const base64 = btoa(binary)

      return `data:image/png;base64,${base64}`
    },
       
  }
}
</script>

<style scoped>
.carousel_contenedor{
  width:100%;
  height:100%;
}

.carousel{
  width:100%;
  height:100%;
  position:relative;
  overflow:hidden;
}

/* desaparecer flechas inicialmente */
.carousel .arrow{
  transition:opacity .3s ease;
  opacity: 0;
}

/* mostrar flechas al hacer hover */
.carousel:hover .arrow{
  opacity: 1;
}

.carousel-track{
  display:flex;
    width:100%;
    height:100%;
  transition:transform .6s ease;
}
.slide{
    flex: 0 0 100%;
    width:100%;
    height:100%;
    position:relative;

    display:flex;
    justify-content:center;
    align-items:center;
    overflow:hidden;
}


/* fondo generado de la imagen */
.slide-bg{
  position:absolute;
  /*inset:0;*/
  background-size:cover;
  background-position:center;
  filter:blur(30px);
  transform:scale(1.2);
  opacity:.7;
}

/* imagen principal */
.slide-img{
    /* width:100%; */
    height:98%;
    object-fit:contain;
    /* display:block; */
    border-radius: 10px !important;
}
/* flechas */

.flechas{
  display: flex;
  justify-content: center;
  align-items: center;
}

.arrow{
  position:absolute;
  top:50%;
  transform:translateY(-50%);
  background:rgba(0,0,0,.4);
  color:white;
  border:none;
  width: 25px;
  height: 25px;
  border-radius:50%;
  cursor:pointer;
  /* font-size:22px; */
  display:flex;
  align-items:center;
  justify-content:center;
  transition:.3s;
  padding: 0;
}

.arrow i{
  font-size: 16px;
}
.arrow:hover{
  background:rgba(0,0,0,.7);
}

.left{ 
  left:20px; 
}

.right{ 
  right:20px; 
}

/* dots */
.dots{
  position:absolute;
  bottom:5px;
  width:100%;
  text-align:center;
}

.dot{
  width:12px;
  height:12px;
  border-radius:50%;
  background: #FF5C5C;
  margin:5px;
  display:inline-block;
  cursor:pointer;
  transition:.3s;
}

.dot.active{
  background:#dc2626;
  transform:scale(1.3);
}


.icono{
  font-size: 12px;
}
</style>


